import { BaseViewModel } from "./base.viewmodel";

export class AboutUsViewModel implements BaseViewModel {
    PageTitle: string = 'About Us';
    tabLocation: number = AboutTabs.tab1;
}

export enum AboutTabs {
    tab1 = 0,
    tab2 = 1,
    tab3 = 2,
}